import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_PRICING_PROFILE_MASSIVE_UPDATE,
  CLEAR_PRICING_PROFILE_MASSIVE_UPDATES,
  FLAG_GETTING_PRICING_PROFILE_MASSIVE_UPDATES,
  FLAG_PRICING_PROFILE_MASSIVE_UPDATE_ACTIVITY,
  GET_PRICING_PROFILE_MASSIVE_UPDATE,
  GET_PRICING_PROFILE_MASSIVE_UPDATES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_PRICING_PROFILE_MASSIVE_UPDATES:
      return state.setIn(['all', 'loading'], payload);
    case GET_PRICING_PROFILE_MASSIVE_UPDATES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_PRICING_PROFILE_MASSIVE_UPDATES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_PRICING_PROFILE_MASSIVE_UPDATE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_PRICING_PROFILE_MASSIVE_UPDATE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_PRICING_PROFILE_MASSIVE_UPDATE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
